module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-578.c546558.woff2";